module.exports = __webpack_public_path__ + "img/logo.247706eb.png";